import React from 'react';
import './screens.css';

// LoadingScreen に「キャンセル」ボタンを追加
const LoadingScreen = ({ text, onCancel }) => {
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p className="loading-text">{text || "読み込み中..."}</p>
      
      {onCancel && (
        <button 
          className="cancel-button"
          onClick={onCancel}
        >
          キャンセル
        </button>
      )}
    </div>
  );
};

export default LoadingScreen;